import React, { Component } from 'react'
import './AnnotationControls.scss';
import AnnotationGroup from 'components/AnnotationGroup';
import {ReactComponent as AddGroup} from '../assets/icons/addGroup.svg'
import {grouping} from '../actions/wizard'


import {connect} from 'react-redux';


class AnnotationControls extends Component<any,any> {

  group = () => {
    const {selectedObjects} = this.props;
    if(selectedObjects.length > 0){
        this.props.grouping(selectedObjects);
    }
  }

  render() {
    const Groups = this.props.fabricInstance._objects.filter(obj => obj.type=='group');
    let defaultGroup = this.props.fabricInstance._objects.filter(obj => obj.type!='group');

    return (
        this.props.fabricInstance._objects && <div className='annote'>
        
        <div style={{height:'90%',overflowY:'scroll',overflowX:'hidden'}}>
        <div>
        {
            
            this.props.fabricInstance._objects && Groups?.map((grp,index) => {
                return <AnnotationGroup selObj={this.props.selectedObjects} groupType ={'created'} key={'created'+index} grp={grp} grpIndex={index}/>
            })
        }
        </div>
        <div >
           {
            defaultGroup.length>0 && <AnnotationGroup groupType ={'default'} key={'DefaultGroup'} grp={defaultGroup} grpIndex={Groups.length}/>

           }
        </div>
        </div>
        <div className={'annote-end'}>
            <div title='Select Objects And Press Shift + G'>
                <AddGroup onClick={this.group}/>
            </div>
        </div>
  
      </div>
  
    )
  }
}

export default connect(
    (state: any) => ({
        fabricInstance:state.wizard.fabricInstance,
        pageDetails:state.wizard.pageDetails,
        selectedObjects:state.wizard.selectedObjects
    }),
    {
        grouping
    }
)(AnnotationControls)